import React, { useEffect } from 'react'
import { Col, Row } from 'reactstrap';
import { connect } from "react-redux";

import ContactList from './_list';
import ContactForm from './_form';
import { clearState } from "../../../redux/actions/genericActions";
import {setApp, setUdn} from "../../../redux/actions/generalActions/mainActions";
import {clearState as clearListState} from "../../../redux/actions/generalActions/listActions";
import {setForm} from "../../../redux/actions/generalActions/formActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {showLoader} from "../../../components/loader/loader";
import {ButtonNew} from "../../../components/buttons/buttonsActions";

const Contact = props => {
    const { loading } = props.mainProps

    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState();
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);

        const udn = localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')) : null

        if (udn !== null)
            props.setUdn(udn);
    },[]);

    const createItem = () => {
        props.setForm()
        ModalFormContainer(ContactForm, { data: null, Form: ContactForm });
    }

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        <div className="ml-auto paddingAdd">
                            <ButtonNew onClick={createItem}/>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <ContactList/>
                </Col>
            </Row>
        </div>
    )
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setForm,
    setApp,
    clearListState
});

export default connect(mapStateToProps, mapActionsToProps)(Contact)
